import { SerializedPlainDate } from './api/data.types';
import { ContractRole } from './contract.types';

/** Contact data fields  */
export interface ResidentContact {
  contactId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  birthDate: string;
  phoneNumber: string;
}

export interface Resident {
  roleOption: ContractRole;
  beginDate: SerializedPlainDate;
  endDate: SerializedPlainDate | null;
  paymentsEndDate: null;
  // TODO: add backend support
  isOmaSATOUser?: boolean;
}

/** Residents that are part of the rental contract */
export interface ContractPartyResident extends Resident, ResidentContact {
  roleOption: 'PARTY';
}

/** Residents that are not part of the rental contract */
export interface NonContractPartyResident
  extends Resident,
    // occupant doesn't necessarily have any contact data associated with it
    Partial<ResidentContact> {
  occupantId: string;
  roleOption: 'RESIDENT';
}

export const isNonContractPartyResident = (
  resident: Resident
): resident is NonContractPartyResident => {
  return resident.roleOption === 'RESIDENT';
};

export const isContractPartyResident = (
  resident: Resident
): resident is ContractPartyResident => {
  return resident.roleOption === 'PARTY';
};
